import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VoxDay from "../pages/voxday/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/voxday",
    element: <VoxDay />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
